// Message Interface - OOP Contract
export enum MessageType {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export enum MessageStatus {
  PENDING = 'PENDING',
  SENT = 'SENT',
  FAILED = 'FAILED',
}

export interface IMessage {
  id: string;
  body: string;
  type: MessageType;
  status: MessageStatus;
  fromId: string;
  createdAt: Date;
  updatedAt: Date;
  recipientsCount: number;
  successCount?: number;
  failedCount?: number;
}

export interface IMessageRecipient {
  id: string;
  to: string;
  status: MessageStatus;
  attempt: number;
  lastError?: string;
  deliveredAt?: Date;
}

export interface IMessageDetail extends IMessage {
  recipients: IMessageRecipient[];
}

export type QueueJobStatus = 'queued' | 'running' | 'completed' | 'failed';

export interface IQueueJobResultGroup {
  groupId: string;
  status: 'success' | 'failed';
  response?: IMessage;
  error?: string;
}

export interface IQueueJobResult {
  groupsProcessed: number;
  successItems: number;
  failedItems: number;
  groupResults?: IQueueJobResultGroup[];
}

export interface IQueueJob {
  id?: string;
  jobId?: string;
  type?: string;
  status: QueueJobStatus;
  progress: number;
  totalItems: number;
  processedItems: number;
  successItems: number;
  failedItems: number;
  message?: string;
  result?: IQueueJobResult;
  error?: string;
  createdAt?: string;
  startedAt?: string;
  finishedAt?: string;
}
